import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

// Sentry
import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

// Import the plugin here
import { auth } from './services/auth';

// Moment
import moment from 'moment';
Vue.filter('moment', function (value, format = 'YYYY-MM-DD') {
  return moment(value).format(format);
});

// Install the authentication plugin here
Vue.use(auth, {
  domain: process.env.VUE_APP_AUTH_ZERO_DOMAIN,
  clientId: process.env.VUE_APP_AUTH_ZERO_CLIENT_ID,
  audience: process.env.VUE_APP_AUTH_ZERO_AUDIENCE,
  onRedirectCallback: (appState: any) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

Vue.config.productionTip = false;

if (process.env.VUE_APP_ENV === 'production') {
  Sentry.init({
    dsn: 'https://84c15003e8d54a8899dc85972259d695@o439795.ingest.sentry.io/5581310',
    autoSessionTracking: true,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.3
  });
}
new Vue({
  router,
  store: store.original,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
